import styled from 'styled-components'

export const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 90px;
  background: var(--light);
  border-bottom: 1px solid var(--grey4);
  z-index: 30;
`

export const HeaderContainer = styled.div`
  max-width: var(--unsignedMaxWidth);
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
`

export const NavDesktop = styled.nav`
  margin-left: 66px;
  height: 100%;
  display: flex;
  align-items: stretch;
  gap: 40px;

  @media only screen and (max-width: 1050px) {
    display: none;
  }
`

export const MenuLink = styled.a<{ active?: boolean }>`
  position: relative;
  height: auto;
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  color: ${({ active }) => (active ? 'var(--blue)' : 'var(--grey3)')};
  transition: color 0.2s ease;

  &:hover {
    color: var(--blue);
  }

  ${({ active }) =>
    active &&
    `
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        border-radius: 10px;
        background: var(--blue);
      }
    `}
`

export const MenuButton = styled.button<{ active?: boolean }>`
  position: relative;
  border: 0;
  background: transparent;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  gap: 4px;
  color: ${({ active }) => (active ? 'var(--blue)' : 'var(--grey3)')};
  height: auto;
  align-self: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 6px;
  transition: color 0.2s ease;

  &:hover {
    color: var(--blue);
  }

  ${({ active }) =>
    active &&
    `
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        border-radius: 10px;
        background: var(--blue);
      }
    `}
`

export const DropdownContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`

export const DropdownMenu = styled.div<{ columnCount?: number }>`
  position: absolute;
  top: calc(100% - 4px);
  left: 0;
  background: var(--light);
  border: 1px solid var(--grey4);
  border-radius: 0 0 10px 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 35px 65px;
  display: flex;
  flex-direction: row;
  gap: 40px;
  min-width: 220px;
`

export const DropdownColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  a,
  button {
    display: block;
    border: 0;
    background: transparent;
    color: var(--grey2);
    font-size: 15px;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    padding: 0;
    transition: color 0.2s ease;
  }

  a:hover,
  button:hover {
    color: var(--blue);
  }
`

export const RightActions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 1050px) {
    gap: 14px;
  }
`

export const DesktopActions = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;

  @media only screen and (max-width: 1050px) {
    display: none;
  }
`

export const RequestButton = styled.a`
  box-shadow: 0px 4px 4px 0px #8d8d8d40;
  width: 100%;
  height: 44px;
  border-radius: 10px;
  padding: 11px 16px;
  background: var(--orange3);
  color: var(--light);
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;

  @media only screen and (max-width: 1050px) {
    width: auto;
    min-width: 168px;
    padding: 10px 14px;
    font-size: 14px;
    line-height: 20px;
  }

  @media only screen and (max-width: 460px) {
    min-width: 150px;
    padding: 10px 12px;
    font-size: 13px;
  }
`

export const MobileRequestButton = styled(RequestButton)`
  display: none;

  @media only screen and (max-width: 1050px) {
    display: inline-flex;
  }
`

export const LoginButton = styled.a`
  width: 100px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid var(--grey4);
  background: var(--light);
  color: var(--grey2);
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`

export const LanguageContainer = styled.div`
  margin-left: 65px;
  position: relative;

  @media only screen and (max-width: 1050px) {
    display: none;
  }
`

export const LanguageButton = styled.button<{ active?: boolean }>`
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${({ active }) => (active ? 'var(--blue)' : 'var(--grey3)')};
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
`

export const LanguageIcon = styled.span`
  display: inline-flex;
  width: 17px;
  height: 17px;
`

export const MobileMenuButton = styled.button`
  display: none;
  border: 0;
  background: transparent;
  width: 38px;
  height: 38px;
  color: var(--grey2);

  span {
    font-size: 30px;
  }

  @media only screen and (max-width: 1050px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`

export const MobileOverlay = styled.aside<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: ${({ open }) => (open ? '0' : '100%')};
  width: 100vw;
  height: 100vh;
  z-index: 40;
  background: var(--light);
  transition: left 0.3s ease;
  padding: 20px;
  display: flex;
  flex-direction: column;
`

export const MobileTop = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const MobileClose = styled.button`
  border: 0;
  background: transparent;
  color: var(--grey2);

  span {
    font-size: 32px;
  }
`

export const MobileNav = styled.nav`
  margin-top: 20px;
  display: grid;
  gap: 18px;

  a,
  button {
    border: 0;
    background: transparent;
    text-align: left;
    color: var(--grey3);
    font-size: 10px;
    font-weight: 600;
    padding: 10px 0;
    transition: color 0.2s;
  }

  /* Add separator to all but the last menu item */
  a:not(:last-child),
  button:not(:last-child) {
    border-bottom: 1px solid #f8f9fd;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  button[data-active='true'] {
    color: #5039dd;
  }
`

export const MobileDropdown = styled.div`
  display: grid;
  gap: 4px;
  margin: 0 0 10px 12px;

  a,
  button {
    font-size: 10px;
    color: #21105d;
    padding: 6px 0;
    transition: color 0.2s;
  }
`

export const MobileBottom = styled.div`
  margin: 0 auto;
  margin-top: auto;
  margin-bottom: 80px;
  gap: 12px;
  max-width: 18pc;
  display: flex;
  flex-direction: column-reverse;
`

export const MobileLangButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`

export const PageOffset = styled.div`
  height: 90px;
`
